// jsx-a11y/click-events-have-key-events
// jsx-a11y/no-static-element-interactions
// jsx-a11y/no-noninteractive-element-interactions
// jsx-a11y/no-noninteractive-element-interactions
import React from 'react';
import { Avatar, Button, Layout } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import { SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from '../../../constants/theme.constants';
import NavProfile from './NavProfile';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

const { Header } = Layout;

interface Props {
  toggleSideBar(): void,
  sidebarCollapsed: boolean,
}

const HeaderNav: React.FC<Props> = ({
  toggleSideBar,
  sidebarCollapsed,
}) => {
  const { authUser } = useSelector((state: RootState) => state.user);

  const navigate = useNavigate();
  const getNavWidth = () => {
    if (sidebarCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    }
    return `${SIDE_NAV_WIDTH}px`;
  };

  return (
    <Header className="app-header">
      <div className="app-header-wrapper">
        <div className="logo" onClick={toggleSideBar}>
          <Avatar 
            style={{ backgroundColor: 'white' }}
            shape='square'
            src={'/img/logo-2-tiger.png'}
            size={64}
          >
          </Avatar>
        </div>
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">
              <li className="ant-menu-item ant-menu-item-only-child" onClick={toggleSideBar}>
                {sidebarCollapsed
                  ? <MenuUnfoldOutlined className="nav-icon" />
                  : <MenuFoldOutlined className="nav-icon" />}
              </li>
            </ul>
          </div>
          <div className="nav-right">
            <NavProfile />
          </div>
        </div>
      </div>
    </Header>
  );
};

export default HeaderNav;
